import { Helmet } from "react-helmet-async";
import { LOCALES, useLocale, useT } from "../i18n";
import { SITE_IMAGERY } from "../config/siteImagery";
import { siteBase } from "../lib/format";
import { useSiteSettings } from "../lib/siteSettings";


export const Seo = ({ title, description, path = "", image }) => {
  useSiteSettings(); // re-render once the runtime SITE_URL has loaded
  const lang = useLocale();
  const t = useT();
  const url = (l) => `${siteBase()}/${l}${path ? `/${path}` : ""}`;
  const fullTitle = title ? `${title} | HAROON TRADING` : t("meta.homeTitle");
  const desc = description || t("meta.homeDescription");
  const ogImage = `${siteBase()}${image || SITE_IMAGERY.hero.variants.large}`;
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url(lang)} />
      {LOCALES.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={url(l)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url("en")} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="HAROON TRADING" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url(lang)} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={t("meta.ogLocale")} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};
